//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../Display/Display.LayerSettingsBuilder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Display.js";
import "../no/Routing.js";
let d=[[[0,"AllowCutElbows",1,0],[1,"LayerSettings",0,"Display.LayerSettingsBuilder",0],[1,"PlacementLocationCollector",0,"Routing.RouteObjectCollector",0],[0,"ReferenceSet",1,0]],[[["elbowSourceNodeIdentifier"],"SetElbowSourceNodeIdentifier",{},1,0],[["placementLocation","selectedMemberIdentifier"],"SelectComponentToBePlaced",{},2,0],[["numberOfPlacedElbowComponents"],"GetPlacedElbowComponents",{R_:{elbowComponents:"Assemblies.Component[]"}},0,0],[["nObjects","logicalObjects"],"PreCommit",{},0,0]],[]];
SPLM.MechanicalRouting.PlaceElbowsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.PlaceElbowsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.PlaceElbowsBuilder.ReferenceSetType = Object.freeze({
    "Model" : "Model", "EntirePart" : "EntirePart", "Empty" : "Empty"});

export default SPLM;